import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { MissionIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createMissionType } from '../../../api/mission-types/create-mission-type'
import UserNavBar from '../../../components/elements/nav-bar'
import { MissionTypeForm } from '../../../components/pages/mission-type/mission-type-form'
import { Paths } from '../../../lib/constants/path'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

export function MissionsCreatePage() {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createMissionType,
    onError: showAxiosError,
    onSuccess: () => toast.success('Type de mission créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un nouveau type de mission'} icon={MissionIcon} />

      <div className={'h-4'} />

      <Box>
        <MissionTypeForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.MISSION_TYPE_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back(Paths.MISSION_TYPE_LIST_PAGE)
          })}
        />
      </Box>
    </div>
  )
}
